import { convertCurrencyToSymbol } from "../../../defaults/defaults";

export type RefundStatus = {
    label: string,
    /** A status word `StatusChip` already has a tone for. */
    tone: string,
}

/**
 * Stripe's refund statuses in words, each borrowing the chip tone of the word that means the same
 * thing elsewhere in HQ, so a refund reads like every other status in the admin.
 */
const STATUSES: Record<string, RefundStatus> = {
    succeeded: { label: 'Succeeded', tone: 'complete' },
    pending: { label: 'Pending', tone: 'pending' },
    requires_action: { label: 'Needs action', tone: 'pending' },
    failed: { label: 'Failed', tone: 'failed' },
    canceled: { label: 'Cancelled', tone: 'cancelled' },
};

export function refundStatus(status: string | null | undefined): RefundStatus {
    const key: string = String(status ?? '').toLowerCase();

    return STATUSES[key] ?? { label: key === '' ? 'Unknown' : key, tone: key };
}

export function formatRefundAmount(currency: string | null | undefined, amount: number | string | null | undefined): string {
    const value: number = Number(amount);

    return convertCurrencyToSymbol(String(currency ?? '').toLowerCase()) + (Number.isFinite(value) ? value : 0).toFixed(2);
}

export const NOTES_PREVIEW_LENGTH: number = 80;

/** Notes on one line for a table cell. The record's own page shows them in full. */
export function notesPreview(notes: string | null | undefined, length: number = NOTES_PREVIEW_LENGTH): string {
    const flat: string = String(notes ?? '').replace(/\s+/g, ' ').trim();

    return flat.length > length ? flat.slice(0, length).trimEnd() + '…' : flat;
}
